<template>
  <div class="dealer-container">
    <router-link :to="{path:'/dealer'}">
      <div class="wrap">
        <e-title :content="title.field1 || ''"></e-title>
        <img :src="item.href" alt="">
      </div>
    </router-link>
  </div>
</template>

<script>
  import ETitle from '@/components/title'
  import {DealerService, TitleService} from '@/service/IndexService'
  import {DefaultParams, Options} from '@/service/BaseService'
  import LanguageUtils from '@/utils/LanguageUtils'
  import {LayoutEnum, SectionEnum, SpeciesEnum} from '@/enumeration/OptionsEnum'

  const service = new DealerService()
  const titleService = new TitleService()
  const params = new DefaultParams(
    LanguageUtils.justifyLanguage(),
    SectionEnum.INDEX,
    SpeciesEnum.MI,
    LayoutEnum.DEALER
  )
  export default {
    name: 'Dealer',
    components: {
      ETitle
    },
    data () {
      return {
        service,
        titleService,
        title: {},
        item: {},
        image: require('@img/01.JPG')
      }
    },
    methods: {
      getTitle () {
        const options = new Options()
        options.params = params
        options.success = ({item}) => {
          this.title = item || {}
        }
        this.titleService.first(options)
      },
      getData () {
        const options = new Options()
        options.params = params
        options.success = ({item}) => {
          this.item = item || {}
        }
        this.service.first(options)
      }
    },
    created () {
      this.getTitle()
      this.getData()
    }
  }
</script>

<style scoped>

  .dealer-container {
    height: 636px;
  }

  .wrap {
    margin: 0 auto;
    width: calc(var(--inner-width) * 1px);
  }

  .wrap img {
    width: inherit;
    height: 500px;
    object-fit: cover;
  }


</style>
